module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6QVn9"))).then(() => parcelRequire('fThBo'));